module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/navbar/navmenu.style.scss
// module id = 703
// module chunks = 2